export default "__VITE_ASSET__DeSV$D98__"